import Pagination from './Pagination';
export default Pagination;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/pagination/index.js
// module id = 465
// module chunks = 0